import {BaseModule} from "./base/base";

export class ScrollTo extends BaseModule {
    constructor() {
        super();

        const anchor = document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]');
        anchor.forEach(item => {
            if (item.getAttribute('href').length > 1) {
                item.addEventListener('click', (e) => this.scrollTo(e));
            }
        });
    }

    scrollTo(e: Event) {
        e.preventDefault();
        const offset = 140; // header height + margin

        const target = e.currentTarget as HTMLAnchorElement;
        const id = target.getAttribute('href');
        if (!id) return;

        const targetElement = document.querySelector(id) as HTMLElement;
        if (targetElement) {
            const elementTop = targetElement.getBoundingClientRect().top + window.scrollY;

            window.scrollTo({
                top: elementTop - offset,
                behavior: 'smooth'
            });
        }
    }

}
